module.exports = "/fonts/vendor/material-icons/iconmaterial-icons-two-tone.woff2?e2c22f8cedcd54788de212b3bbea8e55";